﻿import {withCapitalized} from "../../../../hocs/withCapitalized";
import {CardItemValue} from "../CardItemValue";

export const CardItemValueWithCapitalized = withCapitalized(CardItemValue);
